import { Component, OnInit } from '@angular/core';
import { DataService } from "../../../services/data.service";
import { Subscription } from 'rxjs';
import { URL_IMG } from '../../../constants/general';

@Component({
  selector: 'app-sidebar-header',
  templateUrl: './sidebar-header.component.html',
  styleUrls: ['./sidebar-header.component.scss']
})
export class SidebarHeaderComponent implements OnInit {

  name:string;
  step:string;
  subscription: Subscription;
  url_img = URL_IMG;

  constructor(private data: DataService) {    
  }

  ngOnInit(): void {
    this.subscription = this.data.currentName.subscribe(name => this.name = name)
  }

  showFirstMessage() {
    const step:string = this.data.getStep();
    if(step === 'registro') {
      return false;
    } else {
      return true;
    }
  }

  showHelloMessage() {
    const step:string = this.data.getStep();
    if(step === 'opciones') {
      return false;
    } else {
      return true;
    }
  }

  showCongratulations() {
    const step:string = this.data.getStep();
    if(step === 'opciones/asistido-thank-you-page') {
      return false;
    } else {
      return true;
    }
  }

  showSteps() {
    const step:string = this.data.getStep();
    switch(step) {
      case 'registro':
        return false;
      break;
      case 'opciones/autonomo-identificacion':
        return false;
      break;
      case 'opciones/autonomo-comprobante':
        return false;
      case 'opciones/autonomo-completa-informacion':
        return false;
      case 'opciones/autonomo-beneficiario':
        return false;
      case 'opciones/autonomo-confirmacion':
        return false;
      break;
      case 'opciones/autonomo-thank-you-page':
        return false;
      break;
      default:
        return true;
        break;
    }
  }

  goLanding():void {
    var url = window.location.origin;
    if(url.indexOf('dev') > 0) {
        window.location.href='https://bursanetmx-dev.actinver.com.mx';
    } else if(url.indexOf('qa') > 0) {
        window.location.href='https://bursanetmx-qa.actinver.com.mx';
    } else {
        window.location.href='https://www.bursanet.mx';
    }    
  }

}
